import React from 'react'

export default function InvitationsIcon({
  className = '',
  fill = 'currentColor',
  size = 29,
}) {
  return (
    <svg
      className={className}
      width={size}
      viewBox="0 0 29 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M28.5912 12.7194C29.0859 11.6683 29.1374 10.4832 28.7458 9.39093C28.3439 8.29862 27.5402 7.42273 26.4891 6.93837L12.9485 0.621489C10.7741 -0.398682 8.1773 0.549348 7.16745 2.72366L6.06482 5.0732H19.4405C22.9854 5.0732 25.8605 7.94823 25.8605 11.4828V18.5828L28.5912 12.7194Z" fill={fill}/>
      <path d="M0.14978 19.7911C0.14978 22.1818 2.09741 24.1397 4.4984 24.1397H19.4404C21.8415 24.1397 23.7994 22.1818 23.7994 19.7911V11.4853C23.7994 9.08435 21.8415 7.13672 19.4404 7.13672H4.4984C2.09741 7.13672 0.14978 9.08435 0.14978 11.4853V19.7911ZM3.82862 18.9976L7.19833 15.6382L4.35418 12.7941C3.95228 12.3922 3.95228 11.743 4.35418 11.3411C4.75602 10.9392 5.40523 10.9392 5.80714 11.3411L11.5263 17.0603C11.7737 17.2973 12.1755 17.2973 12.4126 17.0603L18.1318 11.3411C18.5337 10.9392 19.1931 10.9392 19.595 11.3411C19.9969 11.743 19.9969 12.3922 19.595 12.7941L16.7509 15.6382L20.1206 18.9976C20.5225 19.3995 20.5225 20.059 20.1206 20.4609C19.9145 20.6567 19.6466 20.7597 19.3889 20.7597C19.121 20.7597 18.8634 20.6567 18.6573 20.4609L15.2979 17.0912L13.8759 18.5133C13.3606 19.0182 12.6908 19.3068 11.9694 19.3068C11.2584 19.3068 10.5783 19.0182 10.0734 18.5133L8.65129 17.0912L5.29189 20.4609C5.08578 20.6567 4.82816 20.7597 4.56029 20.7597C4.29235 20.7597 4.03473 20.6567 3.82862 20.4609C3.42672 20.059 3.42672 19.3995 3.82862 18.9976Z" fill={fill}/>
    </svg>
  )
}
